<template>
  <div class="ja-gift">
    <!-- <FormRow class="is-gift">
      <input
        type="checkbox"
        @click="setValue('custom.isGift', !jaGift)"
        :checked="jaGift"
        id="jaGift"
      />
      <FormLabel for="jaGift"> I am giving this subscription as a gift</FormLabel>
    </FormRow>
    <div v-if="jaGift" class="ja-gift-container">
      <FormRow inline>
        <FormCol :flex="2" field="custom.recipientFirstName" />
        <FormCol :flex="2" field="custom.recipientLastName" />
      </FormRow>
      <FormRow inline>
        <FormCol field="custom.recipientStreet" :flex="2" />
        <FormCol field="custom.recipientStreet2" :flex="2" />
      </FormRow>
      <FormRow inline>
        <FormCol field="custom.recipientCountry" :flex="1"><CountrySelector /></FormCol>
        <FormCol field="custom.recipientCity" :flex="1" />
        <FormCol field="custom.recipientState" :flex="1"
          ><StateSelector :country="getValue('custom.recipientCountry')"
        /></FormCol>
        <FormCol field="custom.recipientZip" :flex="1" />
      </FormRow>
      <FormRow inline>
        <FormCol field="custom.recipientEmail" />
        <FormCol field="custom.recipientPhone" />
      </FormRow>
    </div> -->
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, setValue, form } = usePaymentForm();
    const jaGift = computed(() => getValue("custom.isGift"));

    return {
      jaGift,
      form,
      setValue,
      getValue,
    };
  },
});
</script>
<style scoped lang="scss">
input[type="checkbox"] {
  margin-right: 7px;
}
.flex {
  display: flex;
  align-items: center;
}
.ja-gift {
  margin-top: 20px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
}
.is-gift {
  ::v-deep label {
    font-weight: normal;
  }
}
.ja-gift-container {
  margin-top: 30px;
}
</style>
